import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

import { primitiveColors } from './primitives/colors'
import { shadows } from './primitives/shadows'
import { fonts } from './primitives/typography'
import { semanticColors } from './semantic/colors'
import { lightSemanticColors } from './semantic/lightColors'
import { textStyles } from './semantic/textStyles'

export const config = defineConfig({
  cssVarsRoot: ':where(:root, :host)',
  // Scopes all CSS variables to --hw-dark-* to prevent collision with
  // v2-lib (--chakra-*) and Chakra v1 tokens when used on the same page.
  cssVarsPrefix: 'hw-dark',
  // No global resets — consuming app provides them. The one exception is
  // ::selection: content Chakra portals to <body> escapes the DarkProvider
  // selection scope, so this rule lets it follow the app-set selection vars
  // (see SELECTION_BG_VAR in Provider.tsx). Unset, the system Highlight
  // colors keep the browser-default behavior.
  globalCss: {
    '::selection': {
      backgroundColor: 'var(--hw-dark-selection-bg, Highlight)',
      color: 'var(--hw-dark-selection-fg, HighlightText)',
    },
  },
  theme: {
    tokens: {
      colors: primitiveColors,
      fonts,
      shadows,
    },
    semanticTokens: {
      colors: { ...semanticColors, ...lightSemanticColors },
    },
    textStyles,
  },
})

export const system = createSystem(defaultConfig, config)

// Guard against external mutation of cssVarsPrefix.
// Chakra v3's defaultSystem (prefix "chakra") can overwrite the custom prefix
// on shared _config references when both systems coexist in the same bundle.
// Locking the property ensures our "hw-dark" prefix is preserved at runtime.
if (system._config) {
  const prefix = system._config.cssVarsPrefix
  Object.defineProperty(system._config, 'cssVarsPrefix', {
    value: prefix,
    writable: false,
    configurable: false,
  })
}
